import * as React from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'react-final-form';

// Utils
import { isNilOrEmpty, partial } from '@src/shared/src/util/general';
import { minLen, maxLen, composeValidators } from '@toolkit/util/formsValidation';
import { IRootState } from '@src/store';
import { FormInput } from '@toolkit/ui';
import { useTranslation } from 'react-i18next';

const FlightNumberForm: React.FC = () => {
  const { t } = useTranslation();

  const bookingRentals = useSelector((state: IRootState) => state.checkout.rentals);

  const minFlightNumberLenValidate = partial(minLen, [3]);
  const maxFlightNumberLenValidate = partial(maxLen, [6]);

  if (!isNilOrEmpty(bookingRentals)) {
    return (
      <div className="checkout-box checkout-payment box">
        <div className="checkout-form">
          <label className="checkout-form-label">{t('FlightNumberForm.field.label')}</label>
          <Field
            name="flightNumber"
            placeholder={t('FlightNumberForm.field.placeholder')}
            component={FormInput}
            validate={composeValidators(minFlightNumberLenValidate, maxFlightNumberLenValidate)}
          />
        </div>
      </div>
    );
  }
};

export default FlightNumberForm;
